class DevProductRecommendations extends HTMLElement {
  connectedCallback() {
    const hasItems = this.querySelector('.dev-product-recommendations__item');
    if (!hasItems) {
      this.fetchRecommendations();
    }
  }

  async fetchRecommendations() {
    const baseUrl = this.dataset.url;
    const productId = this.dataset.productId;
    const sectionId = this.dataset.sectionId;
    const limit = this.dataset.limit || 3;
    const intent = this.dataset.intent || 'related';

    if (!baseUrl || !productId) {
      this.style.display = 'none';
      return;
    }

    const fetchUrl = `${baseUrl}?product_id=${productId}&section_id=${sectionId}&limit=${limit}&intent=${intent}`;

    try {
      const response = await fetch(fetchUrl);

      if (!response.ok) {
        this.style.display = 'none';
        return;
      }

      const html = await response.text();
      const temp = document.createElement('div');
      temp.innerHTML = html;

      const freshItems = temp.querySelectorAll('.dev-product-recommendations__item');

      if (freshItems.length > 0) {
        const grid = this.querySelector('[data-rec-grid]');
        if (grid) {
          grid.innerHTML = '';
          freshItems.forEach((item) => {
            grid.appendChild(item.cloneNode(true));
          });
        }
      } else {
        this.style.display = 'none';
      }
    } catch {
      this.style.display = 'none';
    }
  }
}

customElements.define('dev-product-recommendations', DevProductRecommendations);
